import { connect } from 'react-redux';
import { removeFlag } from '../../../actions/Flags';
import Flags from '../components/Flags';
const mapStateToProps = state => ({
  flags: state.flags.flags
});
const mapDispatchToProps = dispatch => ({
  doRemoveFlag: key => dispatch(removeFlag(key))
});
export default connect(mapStateToProps, mapDispatchToProps)(Flags);